module.exports = __webpack_public_path__ + "img/greyDownDirect.bba281af.svg";